import { IMAGE_MAPPING } from './constants';

export const getOptimizedImage = (originalUrl: string): string => {
  return (
    IMAGE_MAPPING[originalUrl as keyof typeof IMAGE_MAPPING] || originalUrl
  );
};

export const isDefaultImage = (url: string): boolean => {
  return url in IMAGE_MAPPING;
};
